module.exports = __webpack_public_path__ + "media/images/icons/share_button-ed33c4ab3340d70a2ecbb180c7c665e7.svg";